const pages = {
  about: {
    title: 'Sobre Reserve Connect',
    description: 'Conectando viajeros a las mejores experiencias en Serra Catarinense.',
  },
  contact: {
    title: 'Contáctenos',
    description: 'Póngase en contacto con nuestro equipo.',
  },
  groups: {
    title: 'Grupos y Agencias',
    description: 'Soluciones especiales para grupos y agencias de viajes.',
    formUnavailable: 'Formulario temporalmente no disponible. Contáctenos por WhatsApp.',
  },
  cityGuide: {
    title: 'Qué hacer en Urubici SC',
    subtitle: 'Atracciones, Cascadas y Aventuras',
  },
  terms: { title: 'Términos de Uso' },
  privacy: { title: 'Política de Privacidad' },
  cookies: { title: 'Política de Cookies' },
  cancellation: { title: 'Política de Cancelación y Reembolso' },
  restaurants: { title: 'Restaurantes en Urubici' },
  experiences: { title: 'Experiencias en Urubici' },
  events: { title: 'Eventos en Urubici' },
  notFound: {
    title: 'Página no encontrada',
    description: 'La página que busca no existe o ha sido movida.',
    backHome: 'Volver al inicio',
  },
  city: {
    heroTitle: 'Alojamiento en {{cityName}} con disponibilidad en tiempo real',
    heroDescription: 'Reserve directamente con hoteles locales, con actualización automática de disponibilidad.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Huéspedes',
    guest_1: '1 huésped',
    guest_2: '2 huéspedes',
    guest_3: '3 huéspedes',
    guest_4: '4 huéspedes',
    guest_5: '5 huéspedes',
    guest_6: '6+ huéspedes',
    searchAvailability: 'Buscar disponibilidad',
    directBooking: 'Sin intermediarios. Confirmación directa con el hotel.',
    secureBooking: 'Reserva segura',
    realAvailability: 'Disponibilidad real',
    verifiedHotels: 'Hoteles verificados',
  },
  ondeIr: {
    heroTitle: 'Descubra lo que hace inolvidable a Urubici',
    heroDescription: 'Naturaleza exuberante, frío de verdad y experiencias que piden el alojamiento adecuado.',
    seeNearbyLodging: 'Ver alojamientos cerca de atracciones',
    exploreRoutes: 'Explorar rutas',
    attractionsTitle: 'Atracciones que definen Urubici',
    attractionsDescription: 'Elija la experiencia que combine con usted y encuentre el alojamiento ideal cerca.',
    morroDaIgreja: 'Morro da Igreja',
    morroDaIgrejaDesc: 'Uno de los puntos más altos del Sur de Brasil, con vista impresionante y frío intenso en invierno.',
    seeLodgingNearby: 'Ver alojamientos cercanos',
    serraCorvoBranco: 'Serra do Corvo Branco',
    serraCorvoBrancoDesc: 'Carretera escénica con paredones gigantes y parada obligatoria para motociclistas.',
    lodgingForMotorcyclists: 'Alojamientos ideales para motociclistas',
    cachoeirasSerra: 'Cascadas de la Sierra',
    cachoeirasSerraDesc: 'Naturaleza preservada y senderos para quienes buscan tranquilidad y contacto con el verde.',
    searchNatureLodging: 'Buscar alojamientos en la naturaleza',
    centroHistorico: 'Centro Histórico',
    centroHistoricoDesc: 'Restaurantes, cafés y fácil acceso a los principales puntos de la ciudad.',
    seeDowntownLodging: 'Ver alojamientos en el centro',
    temporadaInverno: 'Temporada de Invierno',
    temporadaInvernoDesc: 'Heladas frecuentes y posibilidad de nieve — alta demanda en esta época.',
    winterLodging: 'Alojamientos para el invierno',
    trilhasMirantes: 'Senderos y Miradores',
    trilhasMirantesDesc: 'Experiencias al aire libre para quienes gustan de la aventura y paisajes únicos.',
    exploreNearbyLodging: 'Explorar alojamientos cercanos',
    routesTitle: 'Rutas para vivir Urubici',
    routesDescription: 'Planifique su estancia con experiencias organizadas y elija el alojamiento ideal para cada perfil de viaje.',
    winterRoute: 'Ruta de Invierno — 2 días en la sierra',
    winterRouteDesc: 'Frío intenso, chimenea, gastronomía y los principales atractivos en un fin de semana perfecto.',
    seeWinterLodging: 'Ver alojamientos para el invierno',
    exploreFullRoute: 'Explorar ruta completa',
    natureRoadRoute: 'Ruta Naturaleza y Carretera',
    natureRoadRouteDesc: 'Serra do Corvo Branco, miradores y senderos para quien ama la carretera, aventura y paisajes únicos.',
    lodgingForBikers: 'Alojamientos ideales para motociclistas',
    seeRouteMap: 'Ver mapa del trayecto',
    whereToStayTitle: 'Dónde hospedarse para cada experiencia',
    whereToStayDescription: 'Elija la región ideal y encuentre alojamientos que combinen con su estilo de viaje.',
    centroRegion: 'Centro Histórico',
    centroRegionDesc: 'Ideal para quien quiere restaurantes, cafés y acceso fácil a los principales atractivos.',
    seeLodgingCentro: 'Ver alojamientos en el Centro',
    morroRegion: 'Morro da Igreja y Altitud',
    morroRegionDesc: 'Perfecto para quien busca frío intenso, chimenea y paisajes impresionantes.',
    seeFireplaceChalets: 'Ver chalets con chimenea',
    serraRegion: 'Serra do Corvo Branco',
    serraRegionDesc: 'Rutas de carretera, miradores y alojamientos con estacionamiento amplio.',
    seeBikerLodging: 'Ver alojamientos para motociclistas',
    finalCtaTitle: 'Elija dónde quedarse mientras vive Urubici',
    finalCtaDescription: 'Los atractivos impresionan. El alojamiento adecuado transforma la experiencia.',
    seeAvailableLodging: 'Ver alojamientos disponibles ahora',
    exploreAdvancedFilters: 'Explorar filtros avanzados',
    realTimeAvailability: 'Disponibilidad en tiempo real',
    directReservation: 'Reserva directa',
    localSupport: 'Soporte local',
    cityPlaceholder: 'Ciudad',
    seoTitle: 'Qué hacer en Urubici SC - Atracciones Turísticas',
    seoDescription: 'Descubra qué hacer en Urubici, SC. Morro da Igreja, Serra do Corvo Branco, cascadas, cañones y atracciones de la Serra Catarinense.',
    breadcrumbHome: 'Inicio',
    breadcrumbWhatToDo: 'Qué hacer',
  },
  restaurantes: {
    heroTitle: 'Sabores que calientan el frío de Urubici',
    heroDescription: 'De la gastronomía serrana a los cafés acogedores, descubra dónde vivir la experiencia completa en la sierra.',
    seeNearbyLodging: 'Ver alojamientos cercanos',
    exploreRestaurants: 'Explorar restaurantes',
    filterByType: 'Filtrar por tipo',
    filterAll: 'Todos',
    filterFineDining: 'Alta gastronomía',
    filterCafes: 'Cafés',
    filterSteakhouse: 'Churrasquerías',
    filterItalian: 'Italiano',
    filterRegional: 'Regional',
    filterNearCenter: 'Cerca del centro',
    recommendedTitle: 'Restaurantes recomendados en Urubici',
    recommendedDescription: 'Curaduría local para completar su viaje — especialmente en invierno.',
    viewDetails: 'Ver detalles',
    nearbyLodging: 'Alojamientos cercanos →',
    highlySought: 'Muy buscado en invierno',
    gastroAccommodationTitle: 'Gastronomía y alojamiento van juntos',
    gastroAccommodationDesc: 'En invierno, los restaurantes más buscados se llenan temprano — y los mejores alojamientos cerca del centro se agotan rápido. Garantice su base en Urubici y viva la experiencia con confort.',
    bulletLessTravel: 'Menos desplazamiento nocturno',
    bulletMoreComfort: 'Más confort en el frío',
    bulletBetterExperience: 'Mejor experiencia en los atractivos',
    seeDowntownLodging: 'Ver alojamientos en el centro',
    centroUrubici: 'Centro de Urubici',
    bestLocationGastro: 'La mejor ubicación para gastronomía',
    finalCtaTitle: 'Ya eligió dónde cenar. Ahora elija dónde quedarse.',
    finalCtaSubtitle: 'Garantice su alojamiento en Urubici con disponibilidad en tiempo real y confirmación inmediata.',
    seeAvailableNow: 'Ver alojamientos disponibles ahora',
    realTimeAvailability: 'Disponibilidad en tiempo real',
    directLocalBooking: 'Reserva directa con establecimientos locales',
    whatsappSupport: 'Soporte humano vía WhatsApp',
    seoTitle: 'Restaurantes en Urubici SC - Gastronomía de la Sierra',
    seoDescription: 'Descubra los mejores restaurantes en Urubici, SC. Alta gastronomía, cafés, churrasquerías y cocina regional de la sierra catarinense.',
    breadcrumbHome: 'Inicio',
    breadcrumbRestaurants: 'Restaurantes',
  },
  restauranteDetalhes: {
    shareAriaLabel: 'Compartir',
    favoriteAriaLabel: 'Favorito',
    previousImage: 'Imagen anterior',
    nextImage: 'Siguiente imagen',
    idealFor: 'Ideal para',
    planYourNight: 'Planifique su noche',
    schedule: 'Horario',
    priceRange: 'Rango de precio',
    highlightsSection: 'Destacados',
    seeNearbyLodging: 'Ver alojamientos cercanos',
    seeMoreRestaurants: 'Ver más restaurantes',
    trustMicrocopy: 'Reserve el alojamiento y disfrute de la sierra con confort.',
    aboutRestaurant: 'Sobre este restaurante',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    highlightsTitle: 'Destacados',
    searchLodgingRegion: 'Buscar alojamiento para esta región',
    exploreUrubici: 'Explorar Urubici',
    location: 'Ubicación',
    howToGetThere: 'Cómo llegar',
    easyAccess: 'Acceso fácil por la SC-110',
    nearCentro: 'Cerca del Centro de Urubici',
    idealWalking: 'Ideal para ir a pie desde alojamientos en el centro',
    tip: 'Consejo',
    tipText: 'En invierno, priorice alojamientos cercanos para evitar desplazamientos largos por la noche.',
    seeAttractionsNearby: 'Ver atracciones cercanas',
    customerReviews: 'Evaluaciones de clientes',
    verifiedReviews: 'evaluaciones verificadas',
    basedOnReal: 'Basado en evaluaciones reales de visitantes.',
    viewAllReviews: 'Ver todas las evaluaciones',
    reviewDisclaimer: 'Contenido ilustrativo. Las evaluaciones se cargarán dinámicamente en el futuro.',
    nearbyAccommodations: 'Alojamientos cercanos',
    nearbyDesc: 'Quédese cerca del centro y aproveche mejor la experiencia.',
    startingAt: 'A partir de',
    perNight: '/ noche',
    seeAllDowntown: 'Ver todos los alojamientos en el centro',
    similarRestaurants: 'Restaurantes similares',
    similarRestaurantsDesc: 'Otras opciones con el mismo ambiente acogedor para noches frías.',
    viewDetails: 'Ver detalles',
    realTimeAvailability: 'Disponibilidad en tiempo real',
    directReservation: 'Reserva directa',
    whatsappSupport: 'Soporte humano vía WhatsApp',
    finalCtaTitle: 'Combine cena y alojamiento con confort',
    reviewPerfectNight: '"Noche perfecta en el frío. Chimenea, vino y platos increíbles."',
    reviewImpeccable: '"Ambiente acogedor y servicio impecable. ¡Volveremos!"',
    service: 'Servicio',
    ambiance: 'Ambiente',
    flavor: 'Sabor',
    valueForMoney: 'Relación calidad-precio',
    winterTip: 'En invierno, garantizar una buena base en el centro hace toda la diferencia para disfrutar Urubici.',
    exploreMore: 'Explorar más restaurantes',
    seoTitle: 'Restaurante en Urubici - Detalles y Evaluaciones',
  },
  experiencias: {
    seoTitle: 'Experiencias en Urubici SC - Aventuras en la Sierra',
    seoDescription: 'Viva experiencias únicas en Urubici, SC. Cañones, cascadas, cabalgatas, degustaciones y aventuras en la Serra Catarinense.',
    heroLabel: 'Descubra la Sierra',
    heroTitle: 'Experiencias Inolvidables',
    heroDescription: 'Desde aventuras extremas hasta momentos de contemplación, encuentre la actividad perfecta para su estancia en Urubici.',
    trustGuides: 'Guías Certificados',
    trustGuidesSub: 'Profesionales locales experimentados',
    trustInsurance: 'Seguro de Aventura',
    trustInsuranceSub: 'Cobertura completa incluida',
    trustFlexible: 'Reserva Flexible',
    trustFlexibleSub: 'Cancele con hasta 48h de antelación',
    curatedTitle: 'Curaduría Premium',
    mainTitle: 'Lo Mejor de Urubici',
    mainDescription: 'Actividades seleccionadas para todos los estilos de viajeros',
    btnDetails: 'Ver detalles',
    ctaTitle: '¿Listo para su próxima aventura?',
    ctaDescription: 'Reserve ahora y garantice su lugar en las experiencias más disputadas de Urubici. Confirmación instantánea directa con los operadores.',
    ctaSearchLodging: 'Buscar Alojamiento',
    ctaNeedHelp: '¿Necesita ayuda?',
    talkToCentral: 'Hable con nuestra central de reservas',
    cards: [
      {
        id: 1,
        title: 'Paseo al Cañón Espraiado',
        description: 'Una de las vistas más impactantes de la Serra Catarinense en un tour guiado exclusivo.',
        image: 'https://readdy.ai/api/search-image?query=stunning%20canyon%20view%20in%20brazilian%20mountains%20dramatic%20cliffs%20foggy%20valley%20morning%20light%20premium%20travel%20photography&width=800&height=600&seq=exp1',
        price: 'R$ 180',
        category: 'Aventura',
      },
      {
        id: 2,
        title: 'Degustación de Vinos de Altitud',
        description: 'Visita a las bodegas premiadas de Urubici con maridaje de quesos locales.',
        image: 'https://readdy.ai/api/search-image?query=luxury%20winery%20tasting%20room%20view%20of%20vineyard%20at%20sunset%20wine%20glasses%20on%20table%20elegant%20atmosphere&width=800&height=600&seq=exp2',
        price: 'R$ 250',
        category: 'Gastronomía',
      },
      {
        id: 3,
        title: 'Cabalgata al Amanecer',
        description: 'Acompañe el despertar de la sierra a caballo por los campos de altitud.',
        image: 'https://readdy.ai/api/search-image?query=horseback%20riding%20at%20sunrise%20in%20misty%20mountains%20silhouette%20outdoor%20adventure%20premium%20experience&width=800&height=600&seq=exp3',
        price: 'R$ 150',
        category: 'Naturaleza',
      },
      {
        id: 4,
        title: 'Expedición Cascada del Avencal',
        description: 'Acceso exclusivo y senderos guiados por la base de la mayor caída de agua de la región.',
        image: 'https://readdy.ai/api/search-image?query=massive%20waterfall%20in%20brazilian%20nature%20lush%20green%20forest%20pristine%20environment%20natural%20beauty&width=800&height=600&seq=exp4',
        price: 'R$ 120',
        category: 'Aventura',
      },
      {
        id: 5,
        title: 'Picnic en Morro da Igreja',
        description: 'Cesta gourmet completa para apreciar el punto más alto del Sur de Brasil.',
        image: 'https://readdy.ai/api/search-image?query=picnic%20with%20stunning%20mountain%20view%20gourmet%20basket%20wine%20comfortable%20setup%20golden%20hour&width=800&height=600&seq=exp5',
        price: 'R$ 320',
        category: 'Romántico',
      },
      {
        id: 6,
        title: 'Tour Fotográfico Nocturno',
        description: 'Capture las estrellas del cielo más límpido de Brasil con orientación profesional.',
        image: 'https://readdy.ai/api/search-image?query=milky%20way%20night%20sky%20over%20mountains%20long%20exposure%20photography%20stunning%20nature&width=800&height=600&seq=exp6',
        price: 'R$ 200',
        category: 'Cultura',
      },
    ],
    breadcrumbHome: 'Inicio',
    breadcrumbExperiences: 'Experiencias',
  },
  eventos: {
    seoTitle: 'Eventos en Urubici SC - Calendario 2026',
    seoDescription: 'Calendario de eventos en Urubici, SC 2026. Festivales, encuentros de motociclistas, invierno y celebraciones culturales en la Serra Catarinense.',
    heroTitle: 'Eventos en Urubici que mueven la sierra',
    heroDescription: 'Planifique su viaje con anticipación y garantice el mejor alojamiento para cada temporada.',
    seeAvailableLodging: 'Ver alojamientos disponibles',
    seeFullCalendar: 'Ver calendario completo',
    filterByType: 'Filtrar por tipo',
    filterAll: 'Todos',
    filterWinter: 'Invierno',
    filterMotorcycle: 'Motociclismo',
    filterCulture: 'Cultura',
    filterNature: 'Naturaleza',
    upcomingEvents: 'Próximos eventos en Urubici',
    upcomingEventsDesc: 'Planifique su alojamiento con anticipación para las fechas más buscadas.',
    seeLodgingDates: 'Ver alojamientos en estas fechas',
    realTimeDates: 'Disponibilidad en tiempo real para las fechas del evento.',
    impactTitle: 'Cómo los eventos impactan el alojamiento en Urubici',
    impactDescription: 'Las fechas especiales elevan la ocupación y agotan las mejores opciones más rápido.',
    occupancyCard1: '+60% de ocupación en invierno',
    occupancyCard1Desc: 'Los fines de semana fríos suelen agotar chalets y posadas con chimenea.',
    occupancyCard2: 'Pico de reservas 30 días antes',
    occupancyCard2Desc: 'Los encuentros de motociclistas aumentan la demanda de alojamientos con estacionamiento.',
    occupancyCard3: 'Heladas y feriados se agotan rápido',
    occupancyCard3Desc: 'Cuando el frío aprieta, la demanda crece en pocas horas.',
    seeLodgingTheseDates: 'Ver alojamientos para estas fechas',
    exploreAdvancedFilters: 'Explorar filtros avanzados',
    planTitle: 'Planifique su viaje para los eventos',
    planDescription: 'Organice su experiencia en Urubici con anticipación.',
    planRestaurants: 'Restaurantes recomendados',
    planRestaurantsDesc: 'Descubra dónde cenar durante los eventos.',
    seeRestaurants: 'Ver restaurantes',
    planRoute: 'Ruta de 2 días',
    planRouteDesc: 'Sugerencia de ruta para aprovechar la sierra.',
    exploreRoute: 'Explorar ruta',
    planHowToGet: 'Cómo llegar',
    planHowToGetDesc: 'Consejos de acceso y mejores rutas.',
    seeDirections: 'Ver orientaciones',
    planWinterGear: 'Qué llevar en invierno',
    planWinterGearDesc: 'Prepárese para el frío intenso.',
    seeTips: 'Ver consejos',
    searchEventLodging: 'Buscar alojamiento para el evento',
    whyReserveTitle: '¿Por qué reservar alojamiento antes de los eventos?',
    whyReserve1: 'Alta ocupación',
    whyReserve1Desc: 'en las temporadas de invierno',
    whyReserve2: 'Encuentro de motociclistas',
    whyReserve2Desc: 'con gran demanda',
    whyReserve3: 'Eventos culturales y festivales',
    whyReserve3Desc: 'con plazas limitadas',
    searchEventLodgingCta: 'Buscar alojamiento para eventos',
    mainEventsTitle: 'Principales eventos y temporadas',
    mainEventsDesc: 'Descubra los mejores momentos para visitar Urubici y garantice su alojamiento',
    winterSeason: 'Temporada de Invierno',
    winterSeasonDesc: 'Alta demanda de chalets y posadas con chimenea.',
    seeWinterLodging: 'Ver alojamientos para el invierno',
    motorcycleMeetup: 'Encuentro de Motociclistas',
    motorcycleMeetupDesc: 'Punto nacional con gran flujo en la sierra.',
    lodgingForBikers: 'Alojamientos ideales para motociclistas',
    festivalsCulture: 'Festivales y Cultura',
    festivalsCultureDesc: 'Planifique su estancia para eventos especiales.',
    searchEventAccommodation: 'Buscar alojamiento para eventos',
    notFoundEvent: '¿No encontró el evento que busca? Vea todas las opciones de alojamiento disponibles.',
    seeAllLodging: 'Ver todos los alojamientos',
    finalCtaTitle: 'Garantice su alojamiento para los próximos eventos',
    finalCtaDesc: 'Evite quedarse sin opciones en las fechas más buscadas. Reserve ahora con disponibilidad en tiempo real.',
    searchAvailableLodging: 'Buscar alojamientos disponibles',
    trustFooter: 'Confirmación inmediata • Sin tarifas ocultas • Soporte local',
    breadcrumbHome: 'Inicio',
    breadcrumbEvents: 'Eventos',
    eventCulture: 'Cultura',
    eventNature: 'Naturaleza',
    eventWinter: 'Invierno',
    eventMotorcycle: 'Motociclismo',
    highDemand: 'Alta demanda en fechas del evento',
    faqQuestion1: '¿Cuál es la mejor época para visitar Urubici?',
    faqAnswer1: 'El invierno (junio-agosto) es ideal para quienes buscan frío y posibilidad de helada. El verano es perfecto para cascadas y senderos. Cada estación tiene su encanto especial.',
    faqQuestion2: '¿Los eventos son gratuitos?',
    faqAnswer2: 'Algunos eventos son gratuitos, otros requieren entrada. Recomendamos verificar la programación específica de cada evento y reservar alojamiento con anticipación.',
  },
  contato: {
    seoTitle: 'Contacto - Reserve Connect Urubici',
    seoDescription: 'Póngase en contacto con la Central de Reservas de Reserve Connect Urubici. Atención vía WhatsApp para dudas sobre alojamientos y eventos.',
    heroLabel: 'Atención',
    heroTitle: 'Hable con la Central de Reserve Connect',
    heroDescription: '¿Dudas sobre alojamientos, eventos, grupos o su reserva? Le ayudamos.',
    whatsappButton: 'Hablar por WhatsApp',
    sendMessage: 'Enviar mensaje',
    whatsappCardTitle: 'WhatsApp',
    whatsappCardDesc: 'Atención humana y ágil para sus dudas.',
    startChat: 'Iniciar conversación',
    emailCardTitle: 'Correo electrónico',
    emailCardDesc: 'Ideal para solicitudes complejas o formales.',
    emailResponseTime: 'Respuesta en hasta 24h',
    faqCardTitle: 'Preguntas Frecuentes',
    faqCardDesc: 'Las respuestas que necesita ahora mismo.',
    accessFaq: 'Acceder FAQ',
    newMessage: 'Nuevo mensaje',
    sending: 'Enviando...',
    formTitle: 'Envíe un mensaje',
    formName: 'Nombre',
    formNamePlaceholder: 'Su nombre completo',
    formWhatsapp: 'WhatsApp',
    formEmail: 'Correo electrónico',
    formEmailOptional: '(opcional)',
    formSubject: 'Asunto',
    formSubjectPlaceholder: 'Seleccione un asunto',
    formSubjectReservation: 'Reserva',
    formSubjectLodging: 'Alojamientos',
    formSubjectEvents: 'Eventos',
    formSubjectGroups: 'Grupos y Agencias',
    formSubjectOther: 'Otro',
    formMessage: 'Mensaje',
    formMessagePlaceholder: '¿Cómo podemos ayudar?',
    formCharLimit: 'Límite de caracteres: 500',
    formSubmit: 'Enviar mensaje',
    formReturnTime: 'Respondemos en hasta 24h.',
    formWhatsappSupport: 'Atención humana vía WhatsApp',
    finalCtaTitle: 'Planifique su viaje con tranquilidad.',
    seeAvailableLodging: 'Ver alojamientos disponibles',
    realTimeAvailability: 'Disponibilidad en tiempo real',
    directReservation: 'Reserva directa',
    localSupport: 'Soporte local',
    breadcrumbHome: 'Inicio',
    breadcrumbContact: 'Contacto',
  },
  sobre: {
    seoTitle: 'Sobre Urubici SC - Guía Completa de la Ciudad',
    seoDescription: 'Conozca Urubici, la perla de la Serra Catarinense. Historia, clima, mejor época para visitar y todo sobre este destino único en el sur de Brasil.',
    heroTitle: 'Urubici by Reserve Connect',
    heroDescription: 'Una plataforma creada para conectar viajeros a las mejores experiencias y alojamientos de la sierra.',
    seeAvailableLodging: 'Ver alojamientos disponibles',
    exploreCity: 'Explorar la ciudad',
    positioningTitle: 'Más que un sitio web. Una infraestructura de reservas local.',
    positioningDescription: 'Reserve Connect nace con un propósito claro: organizar la oferta de alojamientos, restaurantes y experiencias de Urubici en una plataforma moderna, segura y enfocada en la conversión.',
    techTitle: 'Tecnología propia',
    techDesc: 'Disponibilidad en tiempo real e integración con la red local.',
    curationTitle: 'Curaduría regional',
    curationDesc: 'Establecimientos seleccionados y verificados.',
    supportTitle: 'Soporte humano',
    supportDesc: 'Atención vía WhatsApp y central de reservas.',
    howItWorks: 'Cómo funciona',
    howItWorksDesc: 'Un viaje simple, directo y seguro.',
    step1Title: 'Elija su experiencia',
    step1Desc: 'Alojamientos, restaurantes, eventos o rutas.',
    step2Title: 'Compare y planifique',
    step2Desc: 'Filtros inteligentes e información clara.',
    step3Title: 'Reserve con confianza',
    step3Desc: 'Disponibilidad en tiempo real y confirmación inmediata.',
    step4Title: 'Viva Urubici',
    step4Desc: 'Con soporte local y experiencias seleccionadas.',
    searchLodgingNow: 'Buscar alojamiento ahora',
    connectedTitle: 'Conectado a la red local de Urubici',
    connectedDesc: 'Reserve Connect integra establecimientos locales, central de reservas y tecnología propia para organizar la oferta turística de la ciudad.',
    securePlatform: 'Plataforma segura',
    protectedPayment: 'Pago protegido',
    humanSupport: 'Atención humana',
    talkToCentral: 'Hablar con la central',
    commitmentTitle: 'Compromiso con la ciudad',
    commitment1: 'Alianza con alojamientos locales',
    commitment2: 'Organización de la oferta turística',
    commitment3: 'Enfoque en conversión y sostenibilidad regional',
    finalCtaTitle: 'Planifique su próximo viaje a Urubici con confianza.',
    finalCtaDesc: 'Tecnología, curaduría local y soporte humano para una experiencia completa.',
    realTimeAvailability: 'Disponibilidad en tiempo real',
    whatsappSupport: 'Soporte vía WhatsApp',
    breadcrumbHome: 'Inicio',
    breadcrumbAbout: 'Sobre Urubici',
  },
  grupos: {
    heroTitle: '¿Viene a Urubici con grupo o agencia?',
    heroDescription: 'Condiciones especiales para excursiones, motoclubes, eventos corporativos y viajes organizados.',
    requestProposal: 'Solicitar propuesta para grupo',
    talkToWhatsapp: 'Hablar con consultor en WhatsApp',
    sectionTitle: 'Para quién organizamos alojamientos',
    sectionDescription: 'Estructuramos la mejor solución para cada perfil de grupo.',
    motoclubes: 'Motoclubes',
    motoclubesDesc: 'Estacionamiento amplio, fácil acceso y alojamientos preparados para grupos de motociclistas.',
    motoclubesCta: 'Solicitar propuesta para motoclub',
    excursions: 'Excursiones',
    excursionsDesc: 'Organización simplificada para grupos de turismo y viajes colectivos.',
    excursionsCta: 'Solicitar propuesta para excursión',
    corporate: 'Corporativo',
    corporateDesc: 'Eventos empresariales, capacitaciones y encuentros ejecutivos en la sierra.',
    corporateCta: 'Solicitar propuesta corporativa',
    churches: 'Iglesias y retiros',
    churchesDesc: 'Retiros espirituales y encuentros con estructura adecuada para grupos.',
    churchesCta: 'Solicitar propuesta para retiro',
    whyTitle: '¿Por qué organizar con Reserve Connect?',
    whyDescription: 'Centralizamos la negociación y estructuramos el mejor alojamiento para su grupo en Urubici.',
    benefit1: 'Negociación centralizada con la red local',
    benefit2: 'Curaduría de alojamientos ideales para grupos',
    benefit3: 'Atención humana vía WhatsApp',
    benefit4: 'Flexibilidad para fechas, perfiles y presupuesto',
    benefit5: 'Soporte antes, durante y después del viaje',
    highlight1: 'Respuesta en hasta 24h',
    highlight2: 'Condiciones especiales para grupos',
    highlight3: 'Soporte local',
    formTitle: 'Solicite una propuesta para su grupo',
    formDescription: 'Cuéntenos el perfil del grupo y las fechas. Regresamos con las mejores opciones de alojamiento en Urubici.',
    formSuccessTitle: '¡Recibimos su solicitud!',
    formSuccessMessage: 'En breve nuestro equipo le contactará por WhatsApp.',
    formSendAnother: 'Enviar otra solicitud',
    formError: 'Ocurrió un error al enviar. Por favor, intente nuevamente.',
    formName: 'Nombre completo',
    formCompany: 'Empresa/Grupo',
    formCompanyPlaceholder: 'Nombre de la empresa o grupo',
    formGroupType: 'Tipo de grupo',
    formGroupTypePlaceholder: 'Seleccione el tipo',
    formGroupTypeMotoclube: 'Motoclub',
    formGroupTypeExcursao: 'Excursión',
    formGroupTypeCorporativo: 'Corporativo',
    formGroupTypeIgreja: 'Iglesia/Retiro',
    formGroupTypeOther: 'Otro',
    formQuantity: 'Cantidad de personas',
    formQuantityPlaceholder: 'Ej: 20',
    formStartDate: 'Fecha inicial',
    formEndDate: 'Fecha final',
    formWhatsapp: 'WhatsApp',
    formEmail: 'Correo electrónico',
    formEmailPlaceholder: 'su@email.com',
    formMessage: 'Mensaje',
    formMessagePlaceholder: 'Cuéntenos más sobre su grupo, necesidades especiales o dudas...',
    formCharLimit: 'caracteres',
    formSending: 'Enviando...',
    formSubmit: 'Recibir propuesta personalizada',
    formMicrocopy: 'Respondemos en hasta 24h. Atención humana vía WhatsApp.',
  },
  legal: {
    lastUpdated: 'Última actualización: Marzo de 2026.',
    terms: {
      institutional: 'Institucional',
      heroTitle: 'Términos de Uso',
      heroDescription: 'Reglas y condiciones para el uso de la plataforma Reserve Connect.',
      seeAvailableLodging: 'Ver alojamientos disponibles',
      talkToCentral: 'Hablar con la Central',
      section1Title: '1. Sobre la Plataforma',
      section1Body: 'Reserve Connect es una plataforma privada de intermediación de alojamientos y experiencias turísticas en Urubici, conectando viajeros a establecimientos socios locales.',
      section2Title: '2. Intermediación',
      section2Body: 'La plataforma actúa como intermediaria entre viajeros y establecimientos. Las reservas se realizan directamente con los socios registrados.',
      section3Title: '3. Disponibilidad e Información',
      section3Body: 'La información de disponibilidad, precios y condiciones es proporcionada por los establecimientos socios y puede sufrir alteraciones sin aviso previo.',
      section4Title: '4. Cancelaciones',
      section4Body: 'Las políticas de cancelación siguen las reglas definidas por cada establecimiento socio, debiendo el usuario consultarlas antes de la confirmación de la reserva.',
      section5Title: '5. Responsabilidades del Usuario',
      section5Body: 'El usuario se compromete a proporcionar información correcta y actualizada al realizar solicitudes o reservas en la plataforma.',
      section6Title: '6. Limitación de Responsabilidad',
      section6Body: 'Reserve Connect no se responsabiliza por eventos derivados de la prestación de servicios por los socios, actuando exclusivamente como facilitador de la conexión.',
      section7Title: '7. Cambios en los Términos',
      section7Body: 'Los presentes Términos de Uso pueden ser actualizados periódicamente para reflejar mejoras en la plataforma o adecuaciones legales.',
      section8Title: '8. Contacto',
      section8Body: 'Para aclaraciones adicionales, póngase en contacto con nuestra Central de Reservas.',
      finalCtaTitle: 'Planifique su próximo viaje a Urubici con confianza.',
      finalCtaDesc: 'Tecnología, curaduría local y soporte humano para una experiencia completa.',
      talkToCentralCta: 'Hablar con la central',
      realTimeAvailability: 'Disponibilidad en tiempo real',
      directReservation: 'Reserva directa',
      whatsappSupport: 'Soporte vía WhatsApp',
    },
    privacy: {
      heroLabel: 'Privacidad',
      heroTitle: 'Política de Privacidad',
      heroDescription: 'Cómo recopilamos, usamos y protegemos sus datos al utilizar Reserve Connect.',
      seeAvailableLodging: 'Ver alojamientos disponibles',
      talkToCentral: 'Hablar con la Central',
      section1Title: '1. Objetivo de esta Política',
      section1Body: 'Esta Política de Privacidad describe cómo Reserve Connect recopila y utiliza información para viabilizar el funcionamiento de la plataforma y mejorar la experiencia del usuario.',
      section2Title: '2. Datos que Podemos Recopilar',
      section2Body: 'Podemos recopilar datos proporcionados por usted (como nombre, email y WhatsApp en formularios), además de datos técnicos de navegación (como páginas accedidas y tipo de dispositivo) para fines de seguridad y mejora de la plataforma.',
      section3Title: '3. Uso de la Información',
      section3Body: 'Utilizamos los datos para: (a) responder solicitudes y propuestas, (b) mejorar la navegación y rendimiento, (c) prevenir fraudes y garantizar seguridad, y (d) viabilizar contacto con la Central cuando se solicite.',
      section4Title: '4. Compartir con Socios',
      section4Body: 'Cuando sea necesario para atención o solicitud de propuesta, la información puede ser compartida con establecimientos socios locales, estrictamente para viabilizar el servicio solicitado.',
      section5Title: '5. Cookies y Tecnologías Similares',
      section5Body: 'Reserve Connect puede utilizar cookies para recordar preferencias y analizar el uso del sitio. Usted puede gestionar cookies a través de su navegador.',
      section6Title: '6. Seguridad',
      section6Body: 'Adoptamos medidas técnicas y organizacionales para proteger datos contra acceso no autorizado, alteración o divulgación.',
      section7Title: '7. Sus Derechos',
      section7Body: 'Usted puede solicitar corrección, actualización o eliminación de datos proporcionados a través de nuestro canal de atención.',
      section8Title: '8. Retención',
      section8Body: 'Mantendremos los datos solo por el tiempo necesario para cumplir las finalidades descritas en esta política u obligaciones legales.',
      section9Title: '9. Contacto',
      section9Body: 'Para solicitudes relacionadas con privacidad, póngase en contacto con la Central de Reservas.',
      finalCtaTitle: 'Privacidad y transparencia en cada conexión.',
      finalCtaDesc: 'Tecnología, curaduría local y soporte humano para una experiencia completa y segura.',
      talkToCentralCta: 'Hablar con la central',
      realTimeAvailability: 'Disponibilidad en tiempo real',
      directReservation: 'Reserva directa',
      whatsappSupport: 'Soporte vía WhatsApp',
    },
    cookies: {
      institutional: 'Institucional',
      heroTitle: 'Política de Cookies',
      heroDescription: 'Entienda cómo usamos cookies para mejorar su experiencia y hacer la navegación más segura.',
      seeAvailableLodging: 'Ver alojamientos disponibles',
      talkToCentral: 'Hablar con la Central',
      section1Title: '1. Qué son las cookies',
      section1Body: 'Las cookies son pequeños archivos de texto enviados y almacenados en su computadora o dispositivo móvil a través de su navegador. Sirven para que el sitio "recuerde" sus acciones y preferencias a lo largo del tiempo, facilitando la navegación y personalizando su experiencia.',
      section2Title: '2. Por qué usamos cookies',
      section2Body: 'Utilizamos cookies para diversos fines esenciales y analíticos, incluyendo:',
      section2Item1Title: 'Funcionamiento y rendimiento:',
      section2Item1Desc: 'Para garantizar que el sitio cargue correctamente y las funcionalidades básicas operen sin errores.',
      section2Item2Title: 'Preferencias de navegación:',
      section2Item2Desc: 'Para recordar sus elecciones, como idioma y filtros de búsqueda, evitando que necesite configurarlos nuevamente.',
      section2Item3Title: 'Métricas y mejora continua:',
      section2Item3Desc: 'Para entender cómo los usuarios interactúan con la plataforma, qué páginas son más visitadas y dónde podemos evolucionar.',
      section3Title: '3. Tipos de cookies',
      section3EssentialsTitle: 'Cookies Esenciales',
      section3EssentialsDesc: 'Indispensables para el funcionamiento del sitio. Sin ellas, los servicios básicos de reserva y seguridad no pueden ser proporcionados.',
      section3PerformanceTitle: 'Cookies de Rendimiento y Analíticas',
      section3PerformanceDesc: 'Recopilan información anónima sobre cómo se usa el sitio. Nos ayudan a corregir fallos y mejorar la velocidad de navegación.',
      section3FunctionalTitle: 'Cookies Funcionales',
      section3FunctionalDesc: 'Permiten funcionalidades avanzadas y personalización, reteniendo elecciones hechas por el usuario durante la sesión.',
      section3MarketingTitle: 'Cookies de Marketing',
      section3MarketingDesc: 'Utilizadas para mostrar anuncios relevantes al perfil del usuario o limitar la frecuencia de exhibición de un anuncio.',
      section4Title: '4. Cómo gestionar cookies',
      section4Body: 'Usted puede gestionar o deshabilitar cookies directamente en las configuraciones de su navegador (Chrome, Safari, Firefox, Edge, etc.). Sin embargo, observe que bloquear cookies esenciales puede impedir el funcionamiento correcto de algunas partes de Reserve Connect, como el proceso de reserva.',
      section5Title: '5. Actualizaciones de esta política',
      section5Body: 'Esta política puede ser actualizada periódicamente para reflejar cambios en nuestras prácticas o por razones operativas, legales o regulatorias. Recomendamos la consulta regular de esta página.',
      finalCtaTitle: 'Transparencia y seguridad en cada etapa.',
      finalCtaDesc: 'Tecnología, curaduría local y soporte humano para una experiencia completa y segura.',
      talkToCentralCta: 'Hablar con la central',
      realTimeAvailability: 'Disponibilidad en tiempo real',
      directReservation: 'Reserva directa',
      whatsappSupport: 'Soporte vía WhatsApp',
    },
    cancellation: {
      heroLabel: 'Políticas',
      heroTitle: 'Cancelación y Reembolso',
      heroDescription: 'Entienda las reglas y procedimientos para cancelaciones y solicitudes de reembolso.',
      seeAvailableLodging: 'Ver alojamientos disponibles',
      talkToCentral: 'Hablar con la Central',
      section1Title: '1. Reglas Generales',
      section1Body: 'Reserve Connect actúa como intermediario entre el viajero y los establecimientos socios. Las políticas de cancelación y reembolso varían según cada socio y deben ser consultadas en el momento de la reserva.',
      section2Title: '2. Plazos para Cancelación',
      section2Body: 'Cada establecimiento define sus propios plazos de cancelación sin multa. Generalmente, las cancelaciones realizadas con gran anticipación permiten el reembolso total o parcial, según la regla de la tarifa elegida.',
      section3Title: '3. Procedimiento de Solicitud',
      section3Body: 'Para solicitar una cancelación, el usuario debe ponerse en contacto directamente con nuestra Central de Reservas vía WhatsApp o email, informando el número de reserva y el motivo de la solicitud.',
      section4Title: '4. Procesamiento de Reembolsos',
      section4Body: 'Una vez aprobado el reembolso por el establecimiento socio, el procesamiento se realizará a través del mismo método de pago utilizado en la reserva. El plazo para que el crédito aparezca en la factura depende del operador de la tarjeta o del banco.',
      section5Title: '5. No-Show (No Comparecencia)',
      section5Body: 'La no comparecencia en la fecha del check-in sin aviso previo en los plazos establecidos será considerada "no-show" e implicará la pérdida del valor pagado, según la política específica del socio.',
      section6Title: '6. Casos Fortuitos o Fuerza Mayor',
      section6Body: 'En situaciones excepcionales que impidan la prestación del servicio por parte del socio o el desplazamiento del viajero, las solicitudes serán analizadas individualmente buscando la mejor solución para ambas partes.',
      finalCtaTitle: 'Seguridad y soporte en cada reserva.',
      finalCtaDesc: 'Tecnología, curaduría local y soporte humano para una experiencia completa y sin sobresaltos.',
      talkToCentralCta: 'Hablar con la central',
      realTimeAvailability: 'Disponibilidad en tiempo real',
      directReservation: 'Reserva directa',
      whatsappSupport: 'Soporte vía WhatsApp',
    },
  },
  tripPlanner: {
    pageTitle: 'Planea tu Viaje',
    pageDescription: 'Arma tu itinerario ideal con alojamientos, restaurantes, experiencias y eventos en la Serra Catarinense.',
    title: 'Planea tu Viaje',
    subtitle: 'Cuéntanos tus fechas e intereses para armar el itinerario perfecto para ti.',
    stepDates: '¿Cuándo vas?',
    stepInterests: '¿Qué te interesa?',
    interestsHint: 'Selecciona los temas que más combinen con tu viaje.',
    continue: 'Continuar',
    planMyTrip: 'Planear mi viaje',
    planning: 'Planeando...',
    planError: 'No se pudo generar el itinerario. Intenta de nuevo.',
    datesRequired: 'Selecciona las fechas de check-in y check-out.',
    yourItinerary: 'Tu Itinerario',
    day: 'Día',
    morning: 'Mañana',
    afternoon: 'Tarde',
    evening: 'Noche',
    relaxDay: 'Día libre para explorar a tu ritmo.',
    whereToStay: 'Dónde alojarse',
    noLodging: 'No se encontraron alojamientos para estas fechas.',
    perNight: 'noche',
    seeAllLodging: 'Ver todos los alojamientos',
    eventsNearby: 'Eventos cercanos',
    seeAllEvents: 'Ver todos los eventos',
    saveYourPlan: 'Guardar itinerario',
    saveHint: 'Guarda tu itinerario para acceder después y compartir.',
    savePlan: 'Guardar itinerario',
    saving: 'Guardando...',
    planSaved: '¡Itinerario guardado!',
    planSavedDesc: 'Tu itinerario ha sido guardado. Usa el enlace para compartir o acceder después.',
    shareLink: 'Enlace del itinerario',
    copied: '¡Copiado!',
    backToResults: 'Volver al itinerario',
    planAnotherTrip: 'Planear otro viaje',
    newSearch: 'Nueva búsqueda',
  },
};
export default pages;
